// DO NOT MODIFIY this file manually
export enum PERMISSIONS {
  PAYMENT_OFFLINE = 'payment_offline',
  PAYMENT_OFFLINE_ONLY = 'payment_offline_only',
  ADMIN_TOOLS__CONFIRM_BATCH = 'admin_tools__confirm_batch',
  ADMIN_TOOLS__DELETE_CACHE = 'admin_tools__delete_cache',
  ADMIN_TOOLS__DELETE_STRIPE_CONNECT_ACCOUNT = 'admin_tools__delete_stripe_connect_account',
  ADMIN_TOOLS__LOCALAZIER = 'admin_tools__localazier',
  ADMIN_TOOLS__MASSIVE_IMPORT_PERIODS = 'admin_tools__massive_import_periods',
  ADMIN_TOOLS__MISC = 'admin_tools__misc',
  ADMIN_TOOLS__ORDER_CANCELLATION = 'admin_tools__order_cancellation',
  ADMIN_TOOLS__ORDER_CREATION = 'admin_tools__order_creation',
  ADMIN_TOOLS__RANDOM_UID = 'admin_tools__random_uid',
  ADMIN_TOOLS__SATISPAY_REFUND = 'admin_tools__satispay_refund',
  ADMIN_TOOLS__SKIPASS_DELAYED = 'admin_tools__skipass_delayed',
  ADMIN_TOOLS__TASKS_RESET = 'admin_tools__tasks_reset',
  ADMIN_TOOLS__TENANT_DUPLICATION = 'admin_tools__tenant_duplication',
  ADMIN_TOOLS__TENANT_UPDATE = 'admin_tools__tenant_update',
  ADMIN_TOOLS__USER_CREATION = 'admin_tools__user_creation',
  ADMIN_TOOLS__VIEW = 'admin_tools__view',
  AVAILABILITY__PRODUCT = 'availability__product',
  AVAILABILITY__STOCK = 'availability__stock',
  AVAILABILITY__TOGGLES = 'availability__toggles',
  AVAILABILITY__VIEW = 'availability__view',
  CAROUSELS__DETAILS = 'carousels__details',
  CAROUSELS__LIST = 'carousels__list',
  CART__DETAILS = 'cart__details',
  CART__LIST = 'cart__list',
  CASSA_SKIPASS__LIST = 'cassa_skipass__list',
  CATEGORIES__DETAILS = 'categories__details',
  CATEGORIES__LIST = 'categories__list',
  TAGS__DETAILS = 'tags__details',
  TAGS__LIST = 'tags__list',
  PRODUCT_OPTIONS__DETAILS = 'product_options__details',
  PRODUCT_OPTIONS__LIST = 'product_options__list',
  PRICES__LIST = 'prices__list',
  PRICES__DETAILS = 'prices__details',
  PRODUCTS__CREATION = 'products__creation',
  PRODUCTS__DETAILS = 'products__details',
  PRODUCTS__DUPLICATE = 'products__duplicate',
  PRODUCTS__LIST = 'products__list',
  PRODUCTS__VARIANTS = 'products__variants',
  PRODUCTS__SLOTS = 'products__slots',
  PRODUCTS__PARTNER_WEBSHOP = 'products__partner_webshop',
  PRODUCTS__CONFIG = 'products__config',
  PRODUCTS__PURCHASE = 'products__purchase',
  PRODUCTS__TERMS = 'products__terms',
  PRODUCTS__IMAGES = 'products__images',
  PRODUCTS__TEXTS = 'products__texts',
  PRODUCTS__SUBPRODUCTS = 'products__subproducts',
  PRODUCTS__PAYMENTS = 'products__payments',
  PRODUCTS__PRICES = 'products__prices',
  PRODUCTS__AVAILABILITY = 'products__availability',
  PRODUCTS__EPP = 'products__epp',
  PRODUCTS__EXTRADATA = 'products__extradata',
  PRODUCTS__PERIODS = 'products__periods',
  PRODUCTS__VARIANT_GROUPS = 'products__variant_groups',
  SEASONS__DETAILS = 'seasons__details',
  SEASONS__LIST = 'seasons__list',
  COUPONS__DETAILS = 'coupons__details',
  COUPONS__LIST = 'coupons__list',
  COUPONS__EDIT = 'coupons__edit',
  DEALER_ORDERS__EXPERIENCE_MUSEUM = 'dealer_orders__experience_museum',
  DEALER_ORDERS__EXPERIENCE = 'dealer_orders__experience',
  DEALER_ORDERS__FOOD = 'dealer_orders__food',
  DEALER_ORDERS__LESSON_HOTEL = 'dealer_orders__lesson_hotel',
  DEALER_ORDERS__LESSON = 'dealer_orders__lesson',
  DEALER_ORDERS__PARKING = 'dealer_orders__parking',
  DEALER_ORDERS__PICKUP = 'dealer_orders__pickup',
  DEALER_ORDERS__RENTAL_BIKE = 'dealer_orders__rental_bike',
  DEALER_ORDERS__RENTAL_HOTEL = 'dealer_orders__rental_hotel',
  DEALER_ORDERS__RENTAL = 'dealer_orders__rental',
  DEALER_ORDERS__TRANSPORT_FERRY = 'dealer_orders__transport_ferry',
  DEALER_ORDERS__TRANSPORT = 'dealer_orders__transport',
  DISCOUNTS__CREATE = 'discounts__create',
  DISCOUNTS__DETAILS = 'discounts__details',
  DISCOUNTS__LIST = 'discounts__list',
  DISCOUNTS__EDIT = 'discounts__edit',
  DISTRICTS__EDIT = 'districts__edit',
  DISTRICTS__DETAILS = 'districts__details',
  DISTRICTS__LIST = 'districts__list',
  EMAILS__DETAILS = 'emails__details',
  EMAILS__LIST = 'emails__list',
  EXPORT__AS_ADMIN = 'export__as_admin',
  EXTERNAL_CODES__DETAILS = 'external_codes__details',
  EXTERNAL_CODES__LIST = 'external_codes__list',
  GALLERIES__DETAILS = 'galleries__details',
  GALLERIES__LIST = 'galleries__list',
  HOTEL_COUPONS__DETAILS = 'hotel_coupons__details',
  HOTEL_COUPONS__EMAIL = 'hotel_coupons__email',
  HOTEL_COUPONS__ENABLE = 'hotel_coupons__enable',
  HOTEL_COUPONS__LIST = 'hotel_coupons__list',
  SKIPASS_GROUPS__LIST = 'skipass_groups__list',
  SKIPASS_GROUPS__DETAILS = 'skipass_groups__details',
  SKIPASS_GROUPS__EMAIL = 'skipass_groups__email',
  SKIPASS_GROUPS__ENABLE = 'skipass_groups__enable',
  SKIPASS_GROUPS__CREATE = 'skipass_groups__create',
  IMPORT_EXPORT__VIEW = 'import_export__view',
  MEMBERSHIPS__LIST = 'memberships__list',
  MEMBERSHIPS__DETAILS = 'memberships__details',
  MEMBERSHIPS__TRANSITS = 'memberships__transits',
  MEMBERSHIPS__TOGGLE = 'memberships__toggle',
  MEMBERSHIPS__RETRY_ASSIGN = 'memberships__retry_assign',
  MEMBERSHIPS__REPLACE = 'memberships__replace',
  MEMBERSHIPS__STATS = 'memberships__stats',
  MEMBERSHIPS__NOTES_VIEW = 'memberships__notes_view',
  MEMBERSHIPS__NOTES_EDIT = 'memberships__notes_edit',
  MEMBERSHIPS__CAPS = 'memberships__caps',
  MEMBERSHIPS__DISCOUNTS = 'memberships__discounts',
  MEMBERSHIPS__AUDITS = 'memberships__audits',
  MEMBERSHIPS__CAP_CHECK = 'memberships__cap_check',
  MEMBERSHIPS__INSURANCE_TOGGLE = 'memberships__insurance_toggle',
  MY_PARTNER__INFO = 'my_partner__info',
  MY_PARTNER__EDIT = 'my_partner__edit',
  MY_PARTNER__PRICES = 'my_partner__prices',
  MY_PARTNER__VIEW = 'my_partner__view',
  MY_PARTNER__EXPORT_USERS = 'my_partner__export_users',
  ORDERS__PARTNER_RESEND_EMAIL = 'orders__partner_resend_email',
  ORDERS__ADMIN_NOTES_VIEW = 'orders__admin_notes_view',
  ORDERS__ADMIN_NOTES_WRITE = 'orders__admin_notes_write',
  ORDERS__REFUND_DISCOUNT_CODE = 'orders__refund_discount_code',
  ORDERS__REFUND_GATEWAY = 'orders__refund_gateway',
  ORDERS__REFUND_OFFLINE = 'orders__refund_offline',
  ORDERS__CANCEL = 'orders__cancel',
  ORDERS__AUDIT = 'orders__audit',
  ORDERS__DEALERS = 'orders__dealers',
  ORDERS__HISTORY = 'orders__history',
  ORDERS__MAILER_ERRORS = 'orders__mailer_errors',
  ORDERS__PAYMENT_ERRORS = 'orders__payment_errors',
  ORDERS__PICKUP = 'orders__pickup',
  ORDERS__DETAILS = 'orders__details',
  ORDERS__ITEM_CANCEL = 'orders__item_cancel',
  ORDERS__ITEM_EDIT = 'orders__item_edit',
  ORDERS__SNOWITCARDS_EDIT = 'orders__snowitcards_edit',
  ORDERS__ITEM_TRANSFERS = 'orders__item_transfers',
  ORDERS__LIST = 'orders__list',
  ORDERS__FILTER_PRODUCT_UID = 'orders__filter_product_uid',
  ORDERS__FILTER_PRODUCT_TYPES = 'orders__filter_product_types',
  ORDERS__FILTER_DISCOUNT_CODES = 'orders__filter_discount_codes',
  ORDERS__FILTER_ZONE_UIDS = 'orders__filter_zone_uids',
  PARTNERS__ADMIN_NOTE_EDIT = 'partners__admin_note_edit',
  PARTNERS__ADMIN_NOTE_VIEW = 'partners__admin_note_view',
  PARTNERS__COMMISSION_EDIT = 'partners__commission_edit',
  PARTNERS__COMMISSION_VIEW = 'partners__commission_view',
  PARTNERS__CREATION = 'partners__creation',
  PARTNERS__GENERAL_EDIT = 'partners__general_edit',
  PARTNERS__GENERAL_VIEW = 'partners__general_view',
  PARTNERS__INFO_EDIT = 'partners__info_edit',
  PARTNERS__INFO_VIEW = 'partners__info_view',
  PARTNERS__POLICY_EDIT = 'partners__policy_edit',
  PARTNERS__POLICY_VIEW = 'partners__policy_view',
  PARTNERS__PROVIDER_EDIT = 'partners__provider_edit',
  PARTNERS__PROVIDER_VIEW = 'partners__provider_view',
  PARTNERS__STRIPE_EDIT = 'partners__stripe_edit',
  PARTNERS__STRIPE_VIEW = 'partners__stripe_view',
  PARTNERS__DETAILS = 'partners__details',
  PARTNERS__LOOKER_STUDIO = 'partners__looker_studio',
  PARTNERS__LIST = 'partners__list',
  POLICIES__DETAILS = 'policies__details',
  POLICIES__LIST = 'policies__list',
  POLICIES__EDIT = 'policies__edit',
  PROVIDER_ORDERS__VIEW = 'provider_orders__view',
  PROVIDER_ORDERS__EXPERIENCE_MUSEUM = 'provider_orders__experience_museum',
  PROVIDER_ORDERS__EXPERIENCE = 'provider_orders__experience',
  PROVIDER_ORDERS__FOOD = 'provider_orders__food',
  PROVIDER_ORDERS__HOTEL = 'provider_orders__hotel',
  PROVIDER_ORDERS__LESSON_HOTEL = 'provider_orders__lesson_hotel',
  PROVIDER_ORDERS__LESSON = 'provider_orders__lesson',
  PROVIDER_ORDERS__RENTAL_BIKE = 'provider_orders__rental_bike',
  PROVIDER_ORDERS__RENTAL_HOTEL = 'provider_orders__rental_hotel',
  PROVIDER_ORDERS__RENTAL = 'provider_orders__rental',
  PROVIDER_ORDERS__SKIPASS_HOTEL = 'provider_orders__skipass_hotel',
  PROVIDER_ORDERS__SKIPASS_RETURN = 'provider_orders__skipass_return',
  PROVIDER_ORDERS__SKIPASS = 'provider_orders__skipass',
  PROVIDER_ORDERS__TRANSPORT = 'provider_orders__transport',
  PROVIDER_ORDERS__TRENITALIA = 'provider_orders__trenitalia',
  PROFILES__LIST = 'profiles__list',
  QUICK_SEARCH__ALL = 'quick_search__all',
  QUICK_SEARCH__CARD = 'quick_search__card',
  QUICK_SEARCH__MEMBERSHIP = 'quick_search__membership',
  QUICK_SEARCH__TRANSITS = 'quick_search__transits',
  QUICK_SEARCH__MEMBERSHIPS_ONLY = 'quick_search__memberships_only',
  REVIEWS__DETAILS = 'reviews__details',
  REVIEWS__LIST = 'reviews__list',
  ROUTES__DETAILS = 'routes__details',
  ROUTES__LIST = 'routes__list',
  SELECTORS__PARTNERS_HIDE = 'selectors__partners_hide',
  SELECTORS__PARTNERS_SELECT_ALL = 'selectors__partners_select_all',
  SELECTORS__PARTNERS_VIEW_ALL = 'selectors__partners_view_all',
  SELECTORS__TENANTS_HIDE = 'selectors__tenants_hide',
  SELECTORS__TENANTS_SELECT_ALL = 'selectors__tenants_select_all',
  SELECTORS__TENANTS_VIEW_ALL = 'selectors__tenants_view_all',
  SHIPPING_METHODS__EDIT = 'shipping_methods__edit',
  SHIPPING_METHODS__DELETE = 'shipping_methods__delete',
  SHIPPING_METHODS__DETAILS = 'shipping_methods__details',
  SHIPPING_METHODS__LIST = 'shipping_methods__list',
  SNOWITCARDS__DETAILS = 'snowitcards__details',
  SNOWITCARDS__LIST = 'snowitcards__list',
  STAGES__DETAILS = 'stages__details',
  STAGES__LIST = 'stages__list',
  TASKS__RUN = 'tasks__run',
  TASKS__LIST = 'tasks__list',
  TASKS__AI_VIEW = 'tasks__ai_view',
  TASKS__AI_LIST = 'tasks__ai_list',
  PERMISSIONS__EDIT = 'permissions__edit',
  PERMISSIONS__LIST = 'permissions__list',
  ROLES__EDIT = 'roles__edit',
  ROLES__LIST = 'roles__list',
  USERS__CREDENTIALS_EDIT = 'users__credentials_edit',
  USERS__CREDENTIALS = 'users__credentials',
  USERS__GENERAL_EDIT = 'users__general_edit',
  USERS__GENERAL = 'users__general',
  USERS__INFO_EDIT = 'users__info_edit',
  USERS__INFO = 'users__info',
  USERS__ITEMS_EDIT = 'users__items_edit',
  USERS__ITEMS = 'users__items',
  USERS__ORDERS = 'users__orders',
  USERS__REFERRALS = 'users__referrals',
  USERS__ROLES_EDIT = 'users__roles_edit',
  USERS__ROLES = 'users__roles',
  USERS__SNOWITCARDS_EDIT = 'users__snowitcards_edit',
  USERS__SNOWITCARDS = 'users__snowitcards',
  USERS__MEMBERSHIPS = 'users__memberships',
  USERS__DETAILS = 'users__details',
  USERS__NOTE_EDIT = 'users__note_edit',
  USERS__NOTE_VIEW = 'users__note_view',
  USERS__VIEW_ADMIN = 'users__view_admin',
  USERS__VIEW_DEFAULT = 'users__view_default',
  USERS__VIEW_PARTNER = 'users__view_partner',
  USERS__LIST = 'users__list',
  USERS__WEBSHOP_SELECT = 'users__webshop_select',
  USERS__PROFILES = 'users__profiles',
  USERS__PROFILES_DETAILS = 'users__profiles_details',
  USERS__CART = 'users__cart',
  USERS__CREATE = 'users__create',
  USERS__EPP = 'users__epp',
  VENUES__DETAILS = 'venues__details',
  VENUES__INFO_EDIT = 'venues__info_edit',
  VENUES__INFO_VIEW = 'venues__info_view',
  VENUES__LIST = 'venues__list',
  VENUES__WAREHOUSE_EDIT = 'venues__warehouse_edit',
  VENUES__WAREHOUSE_VIEW = 'venues__warehouse_view',
  WEBSHOP__CONFIG_APP = 'webshop__config_app',
  WEBSHOP__CONFIG_BACKEND = 'webshop__config_backend',
  WEBSHOP__CONFIG_EMAIL = 'webshop__config_email',
  WEBSHOP__CONFIG_EPP = 'webshop__config_epp',
  WEBSHOP__CONFIG_GENERAL = 'webshop__config_general',
  WEBSHOP__CONFIG_HOTEL = 'webshop__config_hotel',
  WEBSHOP__CONFIG_IFS = 'webshop__config_ifs',
  WEBSHOP__CONFIG_ITINERARY = 'webshop__config_itinerary',
  WEBSHOP__CONFIG_LAYOUTS = 'webshop__config_layouts',
  WEBSHOP__CONFIG_MAIN = 'webshop__config_main',
  WEBSHOP__CONFIG_MARKETING = 'webshop__config_marketing',
  WEBSHOP__CONFIG_PRODUCTS_AVAILABLE = 'webshop__config_products_available',
  WEBSHOP__CONFIG_PRODUCTS = 'webshop__config_products',
  WEBSHOP__CONFIG_REFERRALS = 'webshop__config_referrals',
  WEBSHOP__CONFIG_SATISPAY = 'webshop__config_satispay',
  WEBSHOP__CONFIG_TENANT_MESSAGES = 'webshop__config_tenant_messages',
  WEBSHOP__CONFIG_THEME = 'webshop__config_theme',
  WEBSHOP__CONFIG_WIDGET = 'webshop__config_widget',
  WEBSHOP__CONFIG_VERIFAI = 'webshop__config_verifai',
  WEBSHOP__CONFIG = 'webshop__config',
  WEBSHOP__LIST = 'webshop__list',
  ZONES__EDIT = 'zones__edit',
  ZONES__DETAILS = 'zones__details',
  ZONES__LIST = 'zones__list',
  CHALLENGES__LIST = 'challenges__list',
  CHALLENGES__CREATE = 'challenges__create',
  CHALLENGES__DETAILS = 'challenges__details',
  TURNSTILES__LIST = 'turnstiles__list',
  TURNSTILES__DETAILS = 'turnstiles__details',
}
export default PERMISSIONS;
